import React from 'react';
import Chevron from './Chevron.jsx';
import { SELECT_CHEVRON_CLASS, SELECT_CHEVRON_FIELD_CLASS } from '../styling/controlRecipes';

/**
 * The select chevron (SPEC §C Inputs): the shared Chevron, pointing down, 20 and tertiary
 * ink from SELECT_CHEVRON_CLASS. `inField` places it on a field's inline inset (the field
 * wrapper must be `relative`); otherwise position it with `className`.
 */
export default function SelectChevron({ inField = false, className = '', id }) {
  const placement = inField ? SELECT_CHEVRON_FIELD_CLASS : '';
  return (
    <Chevron
      direction="down"
      className={`${SELECT_CHEVRON_CLASS} ${placement} ${className}`.replace(/\s+/g, ' ').trim()}
      id={id}
    />
  );
}
